export default __webpack_public_path__ + "static/media/gallery_01.11ad5857.jpg";